import { render } from "./daysgroupsBasicComponent.vue?vue&type=template&id=3b20542a&scoped=true"
import script from "./daysgroupsBasicComponent.vue?vue&type=script&lang=js"
export * from "./daysgroupsBasicComponent.vue?vue&type=script&lang=js"

import "./daysgroupsBasicComponent.vue?vue&type=style&index=0&id=3b20542a&scoped=true&lang=css"

import exportComponent from "E:\\项目\\潞安6s移动端\\H5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b20542a"]])

export default __exports__